import { Button, ColorCode } from '@vinted/web-ui';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { clickEvent } from 'libs/common/event-tracker/events';
import { jsx as _jsx } from "react/jsx-runtime";

const HeaderToggleMobileMenu = _ref => {
  let {
    isActive,
    onToggle
  } = _ref;
  const {
    track
  } = useTracking();
  const translate = useTranslate('header');

  function trackClick() {
    track(clickEvent({
      target: ClickableElement.NavigationMenuToggle
    }));
  }

  function handleToggleClick() {
    trackClick();
    onToggle();
  }

  const icon = isActive ? 'x' : 'menu';
  const menuKey = isActive ? 'close' : 'open';
  return /*#__PURE__*/_jsx(Button, {
    onClick: handleToggleClick,
    deprecatedIconName: icon,
    deprecatedIconColor: ColorCode.GreyscaleLevel3,
    styling: Button.Styling.Flat,
    aria: {
      'aria-label': translate("a11y.menu.".concat(menuKey))
    }
  });
};

export default HeaderToggleMobileMenu;